import qs from 'querystring';

export function getShareLabel($i18n, { channel }) {
  switch (`${channel}`.toLowerCase()) {
    case 'em': case 'email': return $i18n.t('share.via-email');
    case 'li': case 'linkedin': return $i18n.t('share.via-linkedin');
    case 'fb': case 'facebook': return $i18n.t('share.via-facebook');
    case 'tw': case 'twitter': return $i18n.t('share.via-twitter');
    case 'wa': case 'whatsapp': return $i18n.t('share.via-whatsapp');
    case 'fbme': case 'messenger': return $i18n.t('share.via-messenger');
    case 'xi': case 'xing': return $i18n.t('share.via-xing');
    default:return null;
  }
}

export function getShareURL($i18n, { channel, shareText, shareUrl, userAgent }) {
  switch (`${channel}`.toLowerCase()) {

    case 'em': case 'email': case 'mailto': {
      return `mailto:?${qs.stringify({ body: `Hi there,\n\nCheckout the following job.\n${shareUrl}`.trim() })}`;
    }

    case 'li': case 'linkedin': {
      return `https://www.linkedin.com/shareArticle?${qs.stringify({ url: shareUrl })}`;
    }

    case 'fb': case 'facebook': {
      return `https://www.facebook.com/sharer/sharer.php?${qs.stringify({ u: shareUrl })}`;
    }

    case 'fbme': case 'messenger': case 'fb-messenger': {
      /* eslint-disable camelcase */
      const app_id = '495520037510158';
      const link = shareUrl; // will error on localhost
      const redirect_uri = window.location.href;

      return /iPhone|iPad|iPod|Android/i.test(`${userAgent || ''}`)
        ? `fb-messenger://share?${qs.stringify({ app_id, link })}`
        : `http://www.facebook.com/dialog/send?${qs.stringify({ app_id, link, redirect_uri })}`;
    }

    case 'tw': case 'twitter': {
      return `https://twitter.com/intent/tweet?${qs.stringify({ text: `${shareText || ''} ${shareUrl}`.trim() })}`;
    }

    case 'wa': case 'whatsapp': {
      return `https://wa.me/?${qs.stringify({ text: `${shareText || ''} ${shareUrl}`.trim() })}`;
    }

    case 'xi': case 'xing': {
      return `https://www.xing.com/spi/shares/new?${qs.stringify({ url: shareUrl })}`;
    }

    default:
      return shareUrl;
  }
}



// WEBPACK FOOTER //
// ./src/lib/share.js